import { Badge, Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { FiMoreHorizontal } from "react-icons/fi";
import { goalChip } from "../../helpers/goals";

/**
 * Shared frame for every goal type: title, status chip, ⋯ affordance.
 * Paused goals stay visible but dimmed.
 */
const GoalCard = ({ goal, subtitle, onManage, children, compact = false }) => {
  const chip = goalChip(goal);
  const dimmed = goal.status === "paused";

  return (
    <Box
      bg="#171C2D"
      border="1px solid"
      borderColor="#30384E"
      borderRadius="xl"
      mb="3"
      opacity={dimmed ? 0.65 : 1}
      px={{ base: 4, md: 5 }}
      py={{ base: 4, md: 5 }}
      role="group"
      aria-label={goal.title}
    >
      <Flex align="flex-start" gap="2">
        <Box flex="1" minW="0">
          <Text
            fontSize={compact ? "lg" : "xl"}
            fontWeight="bold"
            lineHeight="1.2"
          >
            {goal.title}
          </Text>
          {!!subtitle && (
            <Text color="gray.400" fontSize="sm" mt="1">
              {subtitle}
            </Text>
          )}
        </Box>
        {!!chip && (
          <Badge
            borderRadius="full"
            colorScheme={chip.colorScheme}
            fontSize="sm"
            px="3"
            py="1"
            textTransform="none"
            variant="subtle"
            flexShrink={0}
          >
            {chip.label}
          </Badge>
        )}
        {!!onManage && (
          <IconButton
            aria-label={`Manage ${goal.title}`}
            icon={<FiMoreHorizontal />}
            onClick={() => onManage(goal)}
            size="sm"
            variant="ghost"
            color="gray.400"
            flexShrink={0}
            mt="-1"
          />
        )}
      </Flex>
      {children}
    </Box>
  );
};

export default GoalCard;
